import { Button, UIHeading2, UIText1, NumberInput, FormField, UIText3 } from '@cian/ui-kit';
import React from 'react';
import styles from './styles.css';
import { type ValidationError } from '../../types';
import { isMortgageAmountError, isMortgageRateError } from '../../utils';

interface IMortgageFormProps {
  mortgageAmountRemaining?: number;
  mortgageRate?: number;
  onMortgageAmountRemainingChange: (value: number) => void;
  onMortgageRateChange: (value: number) => void;
  onHasNoMortgageClick: () => void;
  onWithMortgageSubmit: () => void;
  isLoading: boolean;
  error: ValidationError;
}

const MAX_MORTGAGE_RATE = 99;
const MAX_MORTGAGE_AMOUNT = 1000000000;

export const MortgageForm: React.FC<IMortgageFormProps> = ({
  mortgageAmountRemaining,
  mortgageRate,
  onMortgageAmountRemainingChange,
  onMortgageRateChange,
  onHasNoMortgageClick,
  onWithMortgageSubmit: onSubmit,
  isLoading,
  error,
}) => {
  return (
    <>
      <UIHeading2>У вас уже есть действуюшая ипотека?</UIHeading2>
      <div className={styles['mortgage-form-description']}>
        <UIText1>Заполните поля, чтобы мы могли предложить вам более выгодную ставку</UIText1>
      </div>
      <div className={styles['mortgage-form-fields']}>
        <FormField label="Ваша текущая ставка" withoutMargin>
          <NumberInput
            data-testid="lead-mortgage-rate-input"
            decimalDigits={2}
            rightAdornment={
              <div className={styles['mortgage-form-input-postfix']}>
                <UIText1>%</UIText1>
              </div>
            }
            required
            max={MAX_MORTGAGE_RATE}
            placeholder="10"
            size="M"
            onChange={onMortgageRateChange}
            value={mortgageRate}
            invalid={isMortgageRateError(error)}
          />
        </FormField>
        <FormField label="Остаток долга" withoutMargin>
          <NumberInput
            data-testid="lead-mortgage-amount-input"
            decimalDigits={2}
            rightAdornment={
              <div className={styles['mortgage-form-input-postfix']}>
                <UIText1>₽</UIText1>
              </div>
            }
            size="M"
            required
            max={MAX_MORTGAGE_AMOUNT}
            placeholder="3000000"
            onChange={onMortgageAmountRemainingChange}
            value={mortgageAmountRemaining}
            invalid={isMortgageAmountError(error)}
          />
        </FormField>
        {error && (
          <div className={styles['error']}>
            <UIText3 color="text-negative-default">{error.text}</UIText3>
          </div>
        )}
      </div>
      <div className={styles['buttons']}>
        <Button
          loading={!!mortgageRate && !!mortgageAmountRemaining && isLoading}
          onClick={onSubmit}
          data-testid="lead-mortgage-submit-button"
        >
          Отправить
        </Button>
        <div className={styles['no-mortgage-button']}>
          <Button
            fullWidth
            disabled={isLoading}
            loading={isLoading}
            theme="stroke_primary"
            onClick={onHasNoMortgageClick}
            data-testid="lead-no-mortgage-button"
          >
            У меня нет ипотеки
          </Button>
        </div>
      </div>
    </>
  );
};
